type Args = {
  blockId: string;
};

export function getCmsTileGridSectionQueryParamName({ blockId }: Args) {
  return `section-${blockId}`;
}
